export const ADMIN_WIDGETS_NAMES = {
  HEADER: 'NewHeader',
  FOOTER: 'NewAdminFooter',
  HERO_BANNER: 'NewHeroBanner',
  RICH_TEXT_WITH_IMAGE: 'RichTextWithImage',
  SLIDESHOW: 'Slideshow',
  RICH_TEXT: 'RichText',
  COLLECTIONS: 'Collections',
  INSTAGRAM_REELS: 'Instagram',
  FEATURED_REELS: 'FeaturedReels',
  FEATURED_COLLECTIONS: 'FeaturedCollection',
  FEATURED_TAGS: 'FeaturedTag',
  FEATURED_CATEGORIES: 'FeaturedCategory',
  CATEGORY: 'Category',
  MULTI_COLUMN_WITH_ICON: 'MultiColumnWithIcon',
  MULTI_COLUMN_WITH_IMAGE: 'MultiColumnWithImage',
  LOGO_SLIDER: 'LogoSlider',
  BLOG_WIDGET: 'NewBlog',
  TESTIMONIAL: 'Testimonials',
  GALLERY: 'Gallery',
  NEW_ANNOUNCEMENT_BAR: 'NewAnnouncementBar',
  WHATSAPP_FLOATING_ICON: 'FloatingWhatsapp',
  PRODUCT_TESTIMONIAL: 'ProductTestimonial',
};

// testimonial to be added later
export const ADMIN_WIDGETS_FOR_BRAND_WEBSITE = [
  ADMIN_WIDGETS_NAMES.HERO_BANNER,
  ADMIN_WIDGETS_NAMES.LOGO_SLIDER,
  ADMIN_WIDGETS_NAMES.FEATURED_REELS,
  ADMIN_WIDGETS_NAMES.MULTI_COLUMN_WITH_ICON,
  ADMIN_WIDGETS_NAMES.MULTI_COLUMN_WITH_IMAGE,
  ADMIN_WIDGETS_NAMES.RICH_TEXT,
  ADMIN_WIDGETS_NAMES.RICH_TEXT_WITH_IMAGE,
  ADMIN_WIDGETS_NAMES.BLOG_WIDGET,
  ADMIN_WIDGETS_NAMES.FOOTER,
  ADMIN_WIDGETS_NAMES.NEW_ANNOUNCEMENT_BAR,
];

export const ADMIN_WIDGETS = {
  HEADER: { type: 'NewHeader', label: 'Header', name: ADMIN_WIDGETS_NAMES.HEADER },
  FOOTER: { type: 'NewAdminFooter', label: 'Header', name: ADMIN_WIDGETS_NAMES.FOOTER },
  HERO_BANNER: {
    type: 'NewHeroBanner',
    name: ADMIN_WIDGETS_NAMES.HERO_BANNER,
    label: 'Hero Banner',
  },
  RICH_TEXT_WITH_IMAGE: {
    type: 'RichTextWithImage',
    name: ADMIN_WIDGETS_NAMES.RICH_TEXT_WITH_IMAGE,
    label: 'Rich text with image',
  },
  SLIDESHOW: {
    type: 'Slideshow',
    name: ADMIN_WIDGETS_NAMES.SLIDESHOW,
    label: 'Slideshow',
  },
  RICH_TEXT: {
    type: 'RichText',
    name: ADMIN_WIDGETS_NAMES.RICH_TEXT,
    label: 'Rich text',
  },
  COLLECTIONS: {
    type: 'Collections',
    name: ADMIN_WIDGETS_NAMES.COLLECTIONS,
    label: 'Collections',
  },
  INSTAGRAM_REELS: {
    type: 'Instagram',
    name: ADMIN_WIDGETS_NAMES.INSTAGRAM_REELS,
    label: 'Instagram',
  },
  FEATURED_REELS: {
    type: 'FeaturedReels',
    name: ADMIN_WIDGETS_NAMES.FEATURED_REELS,
    label: 'FeaturedReels',
  },
  FEATURED_COLLECTIONS: {
    type: 'FeaturedCollection',
    name: ADMIN_WIDGETS_NAMES.FEATURED_COLLECTIONS,
    label: 'Featured Collection',
  },
  FEATURED_CATEGORIES: {
    type: 'FeaturedCategory',
    name: ADMIN_WIDGETS_NAMES.FEATURED_CATEGORIES,
    label: 'Featured Category',
  },
  FEATURED_TAGS: {
    type: 'FeaturedTag',
    name: ADMIN_WIDGETS_NAMES.FEATURED_TAGS,
    label: 'Featured Tag',
  },
  CATEGORY: {
    type: 'Category',
    name: ADMIN_WIDGETS_NAMES.CATEGORY,
    label: 'Category',
  },
  MULTI_COLUMN_WITH_ICON: {
    type: 'MultiColumnWithIcon',
    name: ADMIN_WIDGETS_NAMES.MULTI_COLUMN_WITH_ICON,
    label: 'Multi column with icon',
  },
  MULTI_COLUMN_WITH_IMAGE: {
    type: 'MultiColumnWithImage',
    name: ADMIN_WIDGETS_NAMES.MULTI_COLUMN_WITH_IMAGE,
    label: 'Multi column with image',
  },
  LOGO_SLIDER: {
    type: 'LogoSlider',
    name: ADMIN_WIDGETS_NAMES.LOGO_SLIDER,
    label: 'Logo slider',
  },
  BLOG_WIDGET: {
    type: 'NewBlog',
    name: ADMIN_WIDGETS_NAMES.BLOG_WIDGET,
    label: 'New blog',
  },
  TESTIMONIALS: {
    type: ADMIN_WIDGETS_NAMES.TESTIMONIAL,
    name: ADMIN_WIDGETS_NAMES.TESTIMONIAL,
    label: 'Testimonials',
  },
  GALLERY: {
    type: ADMIN_WIDGETS_NAMES.GALLERY,
    name: ADMIN_WIDGETS_NAMES.GALLERY,
    label: ADMIN_WIDGETS_NAMES.GALLERY,
  },
  NEW_ANNOUNCEMENT_BAR: {
    type: ADMIN_WIDGETS_NAMES.NEW_ANNOUNCEMENT_BAR,
    name: ADMIN_WIDGETS_NAMES.NEW_ANNOUNCEMENT_BAR,
    label: 'Announcement bar',
  },
  WHATSAPP_FLOATING_ICON: {
    type: ADMIN_WIDGETS_NAMES.WHATSAPP_FLOATING_ICON,
    name: ADMIN_WIDGETS_NAMES.WHATSAPP_FLOATING_ICON,
    label: 'Floating WhatsApp',
  },
  PRODUCT_TESTIMONIALS: {
    type: ADMIN_WIDGETS_NAMES.PRODUCT_TESTIMONIAL,
    name: ADMIN_WIDGETS_NAMES.PRODUCT_TESTIMONIAL,
    label: 'Product Testimonial',
  },
};

export const OLD_WIDGET_NAMES = {
  CAROUSEL: 'Carousel',
};
